// import Swiper from 'swiper';
// import 'remodal';

// ナビゲーションアニメーション
// const funcNav = () => {
// 	const areas = document.querySelectorAll('.area');
// 	const navItems = document.querySelectorAll('.side nav li');
// 	if (!areas.length || !navItems.length) return;

// 	const areasArray = [...areas];
// 	const check = (entries) => {
// 		entries.forEach((entry) => {
// 			const index = areasArray.indexOf(entry.target);
// 			if (index === -1) return;

// 			if (entry.isIntersecting) {
// 				navItems.forEach((item) => item.classList.remove('active'));
// 				if (navItems[index]) navItems[index].classList.add('active');
// 			} else {
// 				if (navItems[index]) navItems[index].classList.remove('active');
// 			}
// 		});
// 	};

// 	const options = {
// 		rootMargin: '0px 0px -90% 0px',
// 		threshold: 0,
// 	};

// 	const observer = new IntersectionObserver(check, options);
// 	areas.forEach((target) => observer.observe(target));
// };

// スクロールアニメーション（各.animを個別に判定、表示時にアニメーション発火）
const funcAnim = () => {
	const items = document.querySelectorAll('.anim');
	if (!items.length) return;

	const check = () => {
		const th = window.innerHeight * 0.9;
		items.forEach((el) => {
			if (el.classList.contains('active')) return;
			const r = el.getBoundingClientRect();
			if (r.top < th && r.bottom > 0) el.classList.add('active');
		});
	};

	document.readyState === 'complete' ? check() : window.addEventListener('load', check, { once: true });
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// スムーススクロール
const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);
const duration = 500;

window.addEventListener('DOMContentLoaded', () => {
	// 下部ナビクリック：ラジオをチェックし#contentsにアンカー（.anchorと同じオフセット）
	const footNavi = document.querySelector('.contents__navi--foot');
	if (footNavi) {
		footNavi.addEventListener('click', (e) => {
			const label = e.target.closest('label[for]');
			if (!label) return;

			const input = document.getElementById(label.getAttribute('for'));
			if (!input || input.type !== 'radio') return;
			if (input.checked) {
				e.preventDefault();
				return;
			}

			e.preventDefault();
			input.checked = true;

			const targetElement = document.getElementById('contents');
			if (!targetElement) return;

			const currentPosition = window.scrollY || 0;
			const targetPosition = currentPosition + targetElement.getBoundingClientRect().top - 70;
			const distance = targetPosition - currentPosition;
			const startTime = performance.now();

			const loop = (nowTime) => {
				const time = nowTime - startTime;
				const normalizedTime = time / duration;

				if (normalizedTime < 1) {
					window.scrollTo(0, currentPosition + distance * easeInOut(normalizedTime));
					requestAnimationFrame(loop);
				} else {
					window.scrollTo(0, targetPosition);
				}
			};

			requestAnimationFrame(loop);
		});
	}

	const triggers = document.querySelectorAll('.anchor');
	// const areas = document.querySelectorAll('.area');
	// const navItems = document.querySelectorAll('.side nav li');
	// const areasArray = [...areas];

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			const href = trigger.getAttribute('href');
			if (!href || !href.startsWith('#')) return;

			const targetId = href.slice(1);
			if (!targetId) return;

			const targetElement = document.getElementById(targetId);
			if (!targetElement) return;

			e.preventDefault();
			e.stopPropagation();

			const currentPosition = window.scrollY || 0;
			const targetPosition = currentPosition + targetElement.getBoundingClientRect().top - 70;
			const distance = targetPosition - currentPosition;
			const startTime = performance.now();

			const loop = (nowTime) => {
				const time = nowTime - startTime;
				const normalizedTime = time / duration;

				if (normalizedTime < 1) {
					window.scrollTo(0, currentPosition + distance * easeInOut(normalizedTime));
					requestAnimationFrame(loop);
				} else {
					window.scrollTo(0, targetPosition);

					// funcNav等要素を取る時（発火位置調整）
					// setTimeout(() => {
					// 	const index = areasArray.indexOf(targetElement);
					// 	if (index !== -1 && navItems[index]) {
					// 		navItems.forEach((item) => item.classList.remove('active'));
					// 		navItems[index].classList.add('active');
					// 	}
					// }, 100); // IntersectionObserverの更新を待つ
				}
			};

			requestAnimationFrame(loop);
		});
	});

	// スクロールアニメーション;
	funcAnim();

	// ナビゲーションアニメーション;
	// funcNav();
});
